package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.radar.dataset.PointProperties
import pl.decks.chartjs.style.PointStyle

@Suppress("unused")
@RadarDsl
class PointPropertiesScope {
    private var backgroundColor: JSScriptableIndexable<ChartColor> = JSScriptableIndexable.Static(ChartColor.rgba(0, 0, 0, 0.1f))
    private var borderColor: JSScriptableIndexable<ChartColor> = JSScriptableIndexable.Static(ChartColor.rgba(0, 0, 0, 0.1f))
    private var borderWidth: JSScriptableIndexable<Int> = JSScriptableIndexable.Static(1)
    private var hitRadius: JSScriptableIndexable<Int> = JSScriptableIndexable.Static(1)
    private var radius: JSScriptableIndexable<Int> = JSScriptableIndexable.Static(3)
    private var rotation: JSScriptableIndexable<Float> = JSScriptableIndexable.Static(0f)
    private var style: JSScriptableIndexable<PointStyle> = JSScriptableIndexable.Static(PointStyle.Shaped(PointStyle.Shape.Circle))

    fun backgroundColor(value: ChartColor) { backgroundColor = JSScriptableIndexable.Static(value) }
    fun backgroundColor(values: List<ChartColor>) { backgroundColor = JSScriptableIndexable.PerPoint(values) }
    fun backgroundColor(fn: (dynamic) -> ChartColor) { backgroundColor = JSScriptableIndexable.Scriptable(fn) }

    fun borderColor(value: ChartColor) { borderColor = JSScriptableIndexable.Static(value) }
    fun borderColor(values: List<ChartColor>) { borderColor = JSScriptableIndexable.PerPoint(values) }
    fun borderColor(fn: (dynamic) -> ChartColor) { borderColor = JSScriptableIndexable.Scriptable(fn) }

    fun borderWidth(value: Int) { borderWidth = JSScriptableIndexable.Static(value) }
    fun borderWidth(values: List<Int>) { borderWidth = JSScriptableIndexable.PerPoint(values) }
    fun borderWidth(fn: (dynamic) -> Int) { borderWidth = JSScriptableIndexable.Scriptable(fn) }

    fun hitRadius(value: Int) { hitRadius = JSScriptableIndexable.Static(value) }
    fun hitRadius(values: List<Int>) { hitRadius = JSScriptableIndexable.PerPoint(values) }
    fun hitRadius(fn: (dynamic) -> Int) { hitRadius = JSScriptableIndexable.Scriptable(fn) }

    fun radius(value: Int) { radius = JSScriptableIndexable.Static(value) }
    fun radius(values: List<Int>) { radius = JSScriptableIndexable.PerPoint(values) }
    fun radius(fn: (dynamic) -> Int) { radius = JSScriptableIndexable.Scriptable(fn) }

    fun rotation(value: Float) { rotation = JSScriptableIndexable.Static(value) }
    fun rotation(values: List<Float>) { rotation = JSScriptableIndexable.PerPoint(values) }
    fun rotation(fn: (dynamic) -> Float) { rotation = JSScriptableIndexable.Scriptable(fn) }

    fun style(value: PointStyle) { style = JSScriptableIndexable.Static(value) }
    fun style(values: List<PointStyle>) { style = JSScriptableIndexable.PerPoint(values) }
    fun style(fn: (dynamic) -> PointStyle) { style = JSScriptableIndexable.Scriptable(fn) }

    internal fun build() = PointProperties(
        backgroundColor = backgroundColor,
        borderColor = borderColor,
        borderWidth = borderWidth,
        hitRadius = hitRadius,
        radius = radius,
        rotation = rotation,
        style = style,
    )
}
